<template>
  <consulta
    :columns="columns"
    ref="tabela"
    :process="process"
    classe="tbl-consulta"
    label-lista-vazia="Nenhum indicador pessoal encontrado na base"
  >
    <template #row="{ row }">
      <tr>
        <td width="400px">
          <span class="d-flex align-items-center">
            <a href class="pointer text-uppercase" @click.prevent="$emit('detalhes-pessoa', row)">
              {{ row.nome }}
            </a>

            <span class="d-flex align-items-center" v-if="row.cancelado">

              <i class="fal fa-exclamation-triangle ml-2 text-red"
                 tabindex="-1"
                 title="Indisponibilidade Cancelada" />

              <v-button
                v-if="$root.getPermission({id: 'PERMITIR_DESFAZER_CANCELAR_ORDEM_INDISPONIBILIDADE_RI'})"
                style="width: 20px; height: 20px; padding: 0; display: flex; justify-content: center; align-items: center;"
                :run="desfazerCancelamento"
                :params="[row]"
                class="btn btn-xs btn-outline-danger ml-2"
                title="Desfazer cancelamento da indisponibilidade"
              >
                <i class="fad fa-undo-alt" style="font-size: 11px"></i>
              </v-button>
            </span>
          </span>
          <div v-if="row.cancelado" class="w-100 small text-muted">
            <span v-if="row.usuarioCancelamento"><b>Usuário:</b> {{ row.usuarioCancelamento }}</span>
            <span> | <b>Data:</b> {{ row.cancelamento | datahora }}</span>
            <span> | <b>Motivo:</b> {{ row.motivoCancelamento }}</span>
          </div>
        </td>

        <td width="200px" align="left">
          {{ row.documento }}
        </td>

        <td width="100px" align="left" class="nowrap">
          <v-button
            v-if="$root.getPermission({id: 'PERMITIR_CANCELAR_ORDEM_INDISPONIBILIDADE_RI'}) && !protocoloCnibCancelado && !row.cancelado"
            :button="false"
            class="icon mr-2"
            :run="cancelar"
            :params="[row]"
            position="dropleft"
            title="Cancelar Indisponibilidade"
          >
            <i class="fal fa-ban"></i>
          </v-button>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="p-0">
          <consulta-indisponibilidade-ordem-fichas
            :pessoa="row"
            :ordem-id="ordemId"
            :tipo-cancelamento="tipoCancelamento"
            :protocolo-cnib-cancelado="protocoloCnibCancelado"
            :dominio="dominio"
            :on-cancelar-indisponibilidade="cancelarFicha"
            :on-desfazer-cancelamento="desfazerCancelamentoFicha"
            :on-detalhes-ficha="detalhesFicha"
          />
        </td>
      </tr>
    </template>
  </consulta>
</template>

<script>
import Consulta from "@/components/Consultas/Consulta.vue";
import ConsultaIndisponibilidadeOrdemFichas from "@/components/Indisponibilidade/Consultas/ConsultaIndisponibilidadeOrdemFichas.vue";
import IndisponibilidadeBusiness from "@/business/IndisponibilidadeBusiness";

export default {
  name: "ConsultaIndisponibilidadeOrdemPessoas",

  components: { Consulta, ConsultaIndisponibilidadeOrdemFichas },

  props: {
    ordemId: String,
    tipoCancelamento: [Number, String],
    protocoloCnibCancelado: Boolean,
    dominio: { type: String, default: null },
  },

  computed: {
    columns() {
      return [
        { label: "Nome", field: "nome" },
        { label: "Documento", field: "documento" },
        { label: "", field: null, headerClass: "column__botao", name: "botao" },
      ];
    },
  },

  async mounted() {
    await this.$refs?.tabela?.load();
  },

  methods: {
    async process(sort_by, sort_dir, page_length, page_number) {
      const result = await IndisponibilidadeBusiness.paginationIndisponibilidadeOrdemPessoa(
        sort_by,
        sort_dir,
        page_number,
        page_length,
        {
          filtros: {
            ordemId: this.ordemId,
            tipoCancelamento: this.tipoCancelamento,
            dominio: this.dominio,
          },
        }
      );

      return {
        rows: result.pagina,
        total: result.quantidade,
      };
    },

    cancelar(pessoa) {
      this.$emit("cancelar-indisponibilidade", pessoa, null, true);
    },

    desfazerCancelamento(pessoa) {
      this.$emit("desfazer-cancelamento-indisponibilidade", pessoa, null, true);
    },

    cancelarFicha(pessoa, ficha) {
      this.$emit("cancelar-indisponibilidade", pessoa, ficha);
    },

    desfazerCancelamentoFicha(pessoa, ficha) {
      this.$emit("desfazer-cancelamento-indisponibilidade", pessoa, ficha);
    },

    detalhesFicha(ficha) {
      this.$emit("detalhes-ficha", ficha);
    },

    async reload() {
      await this.$refs?.tabela?.load();
    },
  },
};
</script>

<style lang="scss" scoped>
.tbl-indisp {
  padding: 0;

  td {
    padding-bottom: 0;
  }
}
</style>
